import React, { useContext } from "react";
import VGaurdLogo from "../../../assets/images/logoLogin.svg";
import LoginBanner from "../../../assets/images/loginBanner.svg";
import TextInput from "../../../components/TextInputComponent/TextInput";
import Button from "../../../components/ButtonComponent/Button";
import { Col, Row } from "react-bootstrap";
import "./forgotPassword.css";
import { ForgotPasswordContext } from "../ForgotPasswordView";
import { Spinner } from "react-bootstrap";
import RouteConstants from "../../../constants/routesContent.json";
import { Link } from "react-router-dom";
import AlertBox from "../../../components/AlertComponent/AlertBox";
const ForgotPasswordPage = ({ textConstants }) => {
  const {
    submitForgotPassword,
    forgotEmailId,
    showAlert, 
    setShowAlert,
    setForgotEmailId,
    invalidEmail,
    spinnerStatus,
    alertMessage,
  } = useContext(ForgotPasswordContext);

  return (
    <Row>
      <Col lg={6} className="forgotDiv">
        <div className="forgotMainContainer">
          <div className="forgotVgaurdLogo">
            <img src={VGaurdLogo} />
          </div>
          <div className="container forgotContainer">
            <div className="colwelcome">
              <div className="row align-self-start forgotPasswordText">
                {textConstants.forgotpassword}
              </div>
            </div>
          </div>

          <form className="forgotFormSection">
            <div className="form-group">
              <label className="row align-self-start emailTextforgot">
                Email
              </label>
              <div className="row align-self-start emailTextforgotInput">
                <TextInput
                  placeholder="Your Email Address"
                  type="text"
                  value={forgotEmailId}
                  onChange={(e) => {
                    setForgotEmailId(e.target.value);
                  }}
                />
                {invalidEmail ? (
                  <div className="invalid-text">
                    {textConstants.emailForgotPasswordWarning}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="containerButtonSumbmit">
              <div className="btnCenter">
                <Button
                  className="btnSubmitbottom"
                  text={spinnerStatus ? <Spinner size="sm" /> : "SUBMIT"}
                  onClick={() => {
                    submitForgotPassword();
                  }}
                />
                <AlertBox
                  show={showAlert}
                  setShow={setShowAlert}
                  alertMessage={alertMessage}
                  buttonSubmitText={"OK"}
                  handleSubmit={() => {
                    setShowAlert(false)
                  }}
                />
              </div>
            </div>
          </form>
        </div>
      </Col>
      <Col lg={6} className="forgotBannerDiv">
        <img className="forgotImgBanner" src={LoginBanner} />
      </Col>
    </Row>
  );
};
export default ForgotPasswordPage;
